export default __webpack_public_path__ + "static/pubgm-680782120507b390e9bcba8e831f4788.jpg";